import styled from '@emotion/styled'
import Button from 'portal-modules/common/components/Button'
import { ArrowDownSm } from '@entrata/portals-common/lib/icons'
import { quint } from '@entrata/portals-common/lib/styled-utils'

export const StyledLinksSpan = styled('span')`
  color: ${({ theme }) => theme.blue.system_blue};
  cursor: pointer;
`

export const StyledAccordianArrowDown = styled(ArrowDownSm)`
  transform: rotate(${({ rotation }) => rotation + 'deg'});
  transition: transform 200ms ${quint.easeOut};
  color: ${({ theme, expanded }) =>
    expanded ? theme.black.base : theme.reskinMenu.angle_icon_color};
  margin-right: 10px;
  margin-top: -2px;
`

export const ViewBoletoButton = styled(Button)`
@media only screen and (max-width: 767px) {
  width: max-content;
  margin: 0;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  width: max-content;
}
`